import { Component } from '@angular/core';

@Component({
  selector: 'app-job-seekers-section',
  templateUrl: './job-seekers-section.component.html',
  styleUrls: ['./job-seekers-section.component.css'],
})
export class JobSeekersSectionComponent {
  testimonials: Testimonial[] = [
    {
      id: 1,
      name: 'testimonials.1.name',
      role: 'testimonials.1.role',
      text: 'testimonials.1.text',
      img: 'assets/img/unsplash_Isle-8YpbIQ.png',
    },
    {
      id: 2,
      name: 'testimonials.2.name',
      role: 'testimonials.2.role',
      text: 'testimonials.2.text',
      img: 'assets/img/Rectangle 6.png',
    },
    {
      id: 3,
      name: 'testimonials.3.name',
      role: 'testimonials.3.role',
      text: 'testimonials.3.text',
      img: 'assets/img/unsplash_Isle-8YpbIQ.png',
    },
    {
      id: 4,
      name: 'testimonials.4.name',
      role: 'testimonials.4.role',
      text: 'testimonials.4.text',
      img: 'assets/img/unsplash_Isle-8YpbIQ.png',
    },
  ];

  current = 0;

  // ── Touch swipe support ──
  private touchStartX: number = 0;
  private touchEndX: number = 0;
  private readonly swipeThreshold: number = 50;

  prev(): void {
    this.current =
      (this.current - 1 + this.testimonials.length) % this.testimonials.length;
  }

  next(): void {
    this.current = (this.current + 1) % this.testimonials.length;
  }

  goToSlide(index: number): void {
    this.current = index;
  }

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].clientX;
  }

  onTouchEnd(event: TouchEvent): void {
    this.touchEndX = event.changedTouches[0].clientX;
    this.handleSwipe();
  }

  private handleSwipe(): void {
    const delta = this.touchStartX - this.touchEndX;
    if (Math.abs(delta) < this.swipeThreshold) return;
    if (delta > 0) {
      this.next(); // swiped left → next
    } else {
      this.prev(); // swiped right → prev
    }
  }
}

export interface Testimonial {
  id: number;
  name: string;
  role: string;
  text: string;
  img: string;
}
